(() => {
  const scrollToReviews = (event) => {
    const link = event.target.closest('.elx-product-review-preview');
    if (!link) return;
    const reviews = document.querySelector('#judgeme_product_reviews');
    if (!reviews) return;
    event.preventDefault();
    reviews.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (window.history?.replaceState) window.history.replaceState(null, '', '#judgeme_product_reviews');
  };

  document.addEventListener('click', scrollToReviews);
})();
